export const MAX_TAG_COUNT = 10;
